import { FC } from "react";
import {
  FieldErrorsImpl,
  UseFormHandleSubmit,
  UseFormRegister,
} from "react-hook-form";

import { Field } from "../../(components)/Field";
import { PasswordField } from "../../(components)/PasswordField";
import { LoadingButton } from "../../../(components)/LoadingButton";
import { Routes } from "../../../(utils)/routes";
import IntlLink from "../../../(utils)/IntlLink";

type Props = {
  handleSubmit: UseFormHandleSubmit<any>;
  onSubmit: (data: FormData) => void;
  errors: Partial<FieldErrorsImpl<any>>;
  register: UseFormRegister<any>;
  isSubmitting: boolean;
  t: any;
};

const Form: FC<Props> = ({
  handleSubmit,
  onSubmit,
  errors,
  register,
  isSubmitting,
  t,
}) => {
  const withError = Object.keys(errors).length > 0;

  return (
    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
      <Field
        t={t}
        id="email"
        label="Email"
        type="email"
        placeholder="john@gmail.com"
        error={withError}
        {...register("email")}
      />
      <div>
        <PasswordField
          t={t}
          label={t("password")}
          autoComplete="current-password"
          error={withError}
          {...register("password")}
        />
        {withError && (
          <span className="text-red-500 text-xs">
            {t("email_or_password_error")}
          </span>
        )}
        <p className="text-right mt-4 text-sm font-semibold">
          <IntlLink className="text-primary hover:opacity-70 transition-opacity duration-200" url={Routes.PasswordRecovery}>
            {t("forgot_pass_form")}
          </IntlLink>
        </p>
      </div>

      <div>
        <LoadingButton
          type="submit"
          text={t("sign-in")}
          isLoading={isSubmitting}
          className="mt-10 w-full uppercase font-extrabold text-[14px] text-md-[16px] h-[48px]"
        />
      </div>
    </form>
  );
};

export { Form };
